import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import ForgetPassword from 'views/pages/authentication/authentication3/ForgetPassword';
import AuthCallback from 'views/utilities/Authenticate';
import UserRoles from 'views/utilities/UserRoles';
import ChangePassword from 'views/pages/authentication/authentication3/ChangePassword';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/SignUp')));
const SigninNew = Loadable(lazy(() => import('views/pages/authentication/authentication3/NewSignIn')));
const PaymentSuccess = Loadable(lazy(() => import('views/utilities/PaymentSuccess')));
const DsLogin = Loadable(lazy(() => import('views/pages/DsLogin.js/Structure/index.js')));
// const ChangePassowrd = Loadable(lazy(() => import('views/pages/DsLogin.js/Structure/ForgetPassword')));


// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [

    {
      path: '/',
      element: <SigninNew />
    },
    {
      path: '/old_login',
      element: <AuthLogin3 />
    },
    {
      path: 'paymentsuccess',
      element: <PaymentSuccess />
    },
    {
      path: 'user-role',
      element:<UserRoles/>
    },
    {
      path: 'dslogin',
      element: <DsLogin />
    },
    {
      path: 'dslogin',
      element: <DsLogin />
    },
    {
      path: 'authenticate',
      element: <AuthCallback />
    },
    {
      path: 'forget-password',
      element: <ForgetPassword />
    },
    {
      path: 'change-password',
      element:<ChangePassword/>
    }
   
  ]
};

export default AuthenticationRoutes;
